/* lua.js generated code 0.3.0 */

PushBounceIdleShakeAnim = xClass("PushBounceIdleShakeAnim")
PushBounceIdleShakeAnim.prototype.ctor = function (button) {
    var self = this
    self.downHandler = null
    self.moveInHandler = null
    self.moveOutHandler = null
    self.upHandler = null
    self.upOutHandler = null
    self.button = button
    self.scaleX = self.button.getScaleX()
    self.scaleY = self.button.getScaleY()
    self.animValid = true
    self.useAnim()
}
PushBounceIdleShakeAnim.prototype.useAnim = function () {
    var self = this
    self.animValid = true
    var listening = true
    function onBounceEnable() {
        if (listening) {
            return 
        }
        listening = true
        self.button.stopAction(self.action)
        if (!self.animValid) {
            return 
        }
        self.button.runAction(cc.ScaleTo.create(0.05, 0.85 * self.scaleX, 0.85 * self.scaleY))
    }
    function onBounceDisable() {
        if (!listening) {
            return 
        }
        listening = false
        if (self.action) {
            self.button.stopAction(self.action)
        }
        if (!self.animValid) {
            return 
        }
        self.action = cc.Sequence.create(cc.ScaleTo.create(0.1, self.scaleX * 1.1, self.scaleY * 1.1), cc.ScaleTo.create(0.08, self.scaleX, self.scaleY), cc.CallFunc.create(function () {
            self.action = cc.RepeatForever.create(cc.Sequence.create(cc.DelayTime.create(1), cc.EaseSineIn.create(cc.ScaleTo.create(0.2, self.scaleX * 1.05, self.scaleY * 1.05)), cc.EaseSineOut.create(cc.ScaleTo.create(0.2, self.scaleX, self.scaleY)), cc.EaseSineIn.create(cc.ScaleTo.create(0.2, self.scaleX * 1.05, self.scaleY * 1.05)), cc.EaseSineOut.create(cc.ScaleTo.create(0.2, self.scaleX, self.scaleY))))
            self.button.runAction(self.action)
        }))
        self.button.runAction(self.action)
    }
    var useless
    ;[useless, self.downHandler] = self.button.on(UIButtonEvent.Down, onBounceEnable)
    ;[useless, self.moveInHandler] = self.button.on(UIButtonEvent.MoveIn, onBounceEnable)
    ;[useless, self.upHandler] = self.button.on(UIButtonEvent.Click, onBounceDisable)
    ;[useless, self.moveOutHandler] = self.button.on(UIButtonEvent.MoveOut, onBounceDisable)
    ;[useless, self.upOutHandler] = self.button.on(UIButtonEvent.UpOutside, onBounceDisable)
    onBounceDisable()
}
PushBounceIdleShakeAnim.prototype.removeAnim = function () {
    var self = this
    if (self.action) {
        self.button.stopAction(self.action)
        self.animValid = false
        self.action = null
    }
    self.button.setScaleX(self.scaleX)
    self.button.setScaleY(self.scaleY)
    self.button.removeEventListener(self.downHandler)
    self.button.removeEventListener(self.moveInHandler)
    self.button.removeEventListener(self.moveOutHandler)
    self.button.removeEventListener(self.upHandler)
    self.button.removeEventListener(self.upOutHandler)
}
module.exports = PushBounceIdleShakeAnim
